import script from "./mileageUserTab.vue?vue&type=script&setup=true&name=delivMngTab&lang=js"
export * from "./mileageUserTab.vue?vue&type=script&setup=true&name=delivMngTab&lang=js"

const __exports__ = script;

export default __exports__